import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLock, FaArrowLeft } from 'react-icons/fa';

const NoPermission = () => {
  const navigate = useNavigate();

  return (
    <div className="container-fluid">
      <div className="row justify-content-center align-items-center min-vh-100">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow-lg border-0">
            <div className="card-body text-center p-5">
              <div className="mb-4">
                <FaLock size={80} className="text-danger" />
              </div>
              
              <h2 className="card-title text-danger mb-3">غير مصرح لك</h2>
              
              <p className="card-text text-muted mb-4">
                عذراً، ليس لديك صلاحية للوصول إلى هذه الصفحة.
                <br />
                يرجى التواصل مع المدير للحصول على الصلاحيات المطلوبة.
              </p>
              
              <div className="d-grid gap-2">
                <button 
                  className="btn btn-primary"
                  onClick={() => navigate(-1)}
                >
                  <FaArrowLeft className="me-2" />
                  العودة للصفحة السابقة
                </button>
                
                <button 
                  className="btn btn-outline-secondary"
                  onClick={() => navigate('/')}
                >
                  العودة للرئيسية
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoPermission;
